module.exports = __webpack_public_path__ + "media/images/vp/icon.search-0275fea3240c73ed02839d7404a7b2dc.png";